import { render, staticRenderFns } from "./Vendor.vue?vue&type=template&id=64bdd83f&scoped=true&"
import script from "./Vendor.vue?vue&type=script&lang=js&"
export * from "./Vendor.vue?vue&type=script&lang=js&"
import style0 from "./Vendor.vue?vue&type=style&index=0&id=64bdd83f&prod&lang=css&"
import style1 from "./Vendor.vue?vue&type=style&index=1&id=64bdd83f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bdd83f",
  null
  
)

export default component.exports